import module from 'fan/proyecto/module.js'

export class FanProyectoService {
  constructor($http, Permisos) {
    this.$http = $http
    this.Permisos = Permisos
  }

  get(idProyecto) {
    return this.$http.get('/api2/proyecto', {
      params: {id_proyecto: idProyecto},
    })
  }

  permisos(idcliente) {

    return this.get(idcliente).then((response) => {
      return response.data.permisos
    })
    /*return this.Permisos.modulos({
      colaboradores: 'proyecto.empleados',
      esquemas: 'proyecto.esquemas.ver',
      esquemasEditar: 'proyecto.esquemas.editar',
      filiales: 'proyecto.filiales.ver',
      filialesEditar: 'proyecto.filiales.editar',
      nominas: 'proyecto.nominas',
      configuracion: 'proyecto.configuracion',
    })*/
  }
}

module.service('FanProyectoService', FanProyectoService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto.js